import { BASE_URL } from "../api";
import { apiFetch } from "@shared/api";

export const BILLING_PURCHASE_INIT_ENDPOINT = "/api/billing/purchase/init/";
export const BILLING_PURCHASE_STATUS_ENDPOINT = "/api/billing/purchase/check-status/";
export const PENDING_PURCHASE_STORAGE_KEY = "trackme.pendingPurchase";

const DEFAULT_PURCHASE_DESCRIPTION = "Покупка пакета";
const ABSOLUTE_HTTP_URL_RE = /^https?:\/\//i;

const normalizePackageId = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return null;
  return Math.floor(num);
};

export const buildPackageProductCode = (packageId) => {
  const normalizedPackageId = normalizePackageId(packageId);
  if (!normalizedPackageId) {
    throw new Error("Не удалось определить пакет для оплаты.");
  }

  return `package:${normalizedPackageId}`;
};

export const initPackagePurchase = async ({
  packageId,
  travelPlanId,
  csrfToken,
  description = DEFAULT_PURCHASE_DESCRIPTION,
  phone,
}) => {
  const payload = {
    product_code: buildPackageProductCode(packageId),
    source: "web",
    description: description || DEFAULT_PURCHASE_DESCRIPTION,
    ...(travelPlanId ? { travel_plan_id: String(travelPlanId) } : {}),
    metadata: phone ? { phone } : {},
  };

  const response = await apiFetch(BILLING_PURCHASE_INIT_ENDPOINT, {
    baseUrl: BASE_URL,
    token: localStorage.getItem("accessToken"),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
    },
    body: JSON.stringify(payload),
  });

  const paymentUrl = typeof response?.payment_url === "string" ? response.payment_url.trim() : "";
  const providerErrorCode =
    typeof response?.provider_error_code === "string" ? response.provider_error_code.trim() : "";

  if (!paymentUrl) {
    throw new Error(
      providerErrorCode
        ? `Сервер не вернул ссылку на оплату. Код провайдера: ${providerErrorCode}.`
        : "Сервер не вернул ссылку на оплату."
    );
  }

  if (!ABSOLUTE_HTTP_URL_RE.test(paymentUrl)) {
    throw new Error("Сервер вернул некорректную ссылку на оплату.");
  }

  return {
    ...response,
    payment_url: paymentUrl,
  };
};

export const startPackagePurchase = async (options) => {
  const response = await initPackagePurchase(options);

  if (typeof window !== "undefined") {
    const productCode = buildPackageProductCode(options?.packageId);
    try {
      window.localStorage.setItem(
        PENDING_PURCHASE_STORAGE_KEY,
        JSON.stringify({
          productCode,
          startedAt: new Date().toISOString(),
          orderId: response?.order_id ?? response?.payment_id ?? null,
          travelPlanId: options?.travelPlanId ?? null,
        })
      );
    } catch (error) {
      console.warn("Не удалось сохранить ожидающий подтверждения платёж", error);
    }
    console.log("[billing] purchase init payment_url:", response.payment_url, response);
    window.location.assign(response.payment_url);
  }

  return response;
};

export const checkPackagePurchaseStatus = async ({ orderId, token }) => {
  if (!orderId) return null;
  return apiFetch(BILLING_PURCHASE_STATUS_ENDPOINT, {
    baseUrl: BASE_URL,
    token,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      order_id: orderId,
      force_reconcile: true,
    }),
  });
};
